import ListSSOClients from 'pages/sso-clients/ListSSOClients';
import AddSSOClient from 'pages/sso-clients/AddSSOClient';
import EditSSOClient from 'pages/sso-clients/EditSSOClient';
import { IRoute } from 'interfaces/Route';

export const SSO_CLIENTS_ROUTES: IRoute[] = [
    {
        path: '/admin/sso-clients',
        component: ListSSOClients,
        exact: true,
    },
    {
        path: '/admin/sso-clients/add',
        component: AddSSOClient,
        exact: true,
    },
    {
        path: '/admin/sso-clients/:id/edit',
        component: EditSSOClient,
        exact: true,
    },
];
